import { FC, useEffect, useMemo, useRef } from 'react';
import V2Title from '@/common/components/Feedback/V2Title';
import styles from './index.module.less';
import { TaskChange, TaskStatusTagStyle } from '@/common/components/business/ExpandStore/ts-config';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import { useMethods } from '@lhb/hook';
import V2Operate from '@/common/components/Others/V2Operate';
import { refactorPermissions } from '@lhb/func';

/**
 * @Description 拓店任务title
 */
const TaskDetailTitle:FC<{
  detail,
  titleHeightRef,
}> = ({
  detail,
  titleHeightRef,
}) => {
  const selfRef: any = useRef();

  const operateList = useMemo(() => {
    return [
      /** 是否展示开发异动审批中按钮，异动审批中时展示 */
      {
        name: '开发异动中', event: 'taskApproving', type: 'default',
        disabled: true,
        visible: detail && detail.taskChangeApprovalStatus === TaskChange.Approving
      },
    ].filter(item => item.visible);
  }, [detail]);

  useEffect(() => {
    if (!Object.keys(detail)?.length) return;
    setTimeout(() => {
      titleHeightRef.current = selfRef.current?.getBoundingClientRect()?.height || 0;
    }, 0);
  }, [detail]);

  const methods = useMethods({

    /**
      * @description 点击开发异动中
      */
    handleTaskApproving: () => {
      V2Message.warning(`异动申请中，在我发起的审批中查看`);
    },

  });

  return <div ref={selfRef} className={styles.taskDetailTitleCon}>
    <V2Title
      extra={
        <>
          <V2Operate
            showBtnCount={4}
            operateList={refactorPermissions(operateList)}
            onClick={(btns: { func: string | number }) => methods[btns.func]()}
          />
        </>
      }>
      <div className={styles.titleWrapper}>
        <span className={'fs-20 bold c-222'}>
          {detail?.name}
        </span>
        <div
          className={styles.statusBox}
          style={{
            ...TaskStatusTagStyle[detail?.status]
          }}
        >{detail?.statusName}</div>
      </div>
    </V2Title>
  </div>;
};
export default TaskDetailTitle;
